__turbopack_context__.v({
  "buttonContainer": "DesktopNavigation-module-scss-module__twgJ1a__buttonContainer",
  "customDropdown": "DesktopNavigation-module-scss-module__twgJ1a__customDropdown",
  "divider": "DesktopNavigation-module-scss-module__twgJ1a__divider",
  "dropdown": "DesktopNavigation-module-scss-module__twgJ1a__dropdown",
  "dropdownArrow": "DesktopNavigation-module-scss-module__twgJ1a__dropdownArrow",
  "dropdownArrowExpanded": "DesktopNavigation-module-scss-module__twgJ1a__dropdownArrowExpanded",
  "expandIcon": "DesktopNavigation-module-scss-module__twgJ1a__expandIcon",
  "expandIconExpanded": "DesktopNavigation-module-scss-module__twgJ1a__expandIconExpanded",
  "expandableHeader": "DesktopNavigation-module-scss-module__twgJ1a__expandableHeader",
  "expandableHeaderMain": "DesktopNavigation-module-scss-module__twgJ1a__expandableHeaderMain",
  "itemContent": "DesktopNavigation-module-scss-module__twgJ1a__itemContent",
  "menuItem": "DesktopNavigation-module-scss-module__twgJ1a__menuItem",
  "menuItems": "DesktopNavigation-module-scss-module__twgJ1a__menuItems",
  "navButton": "DesktopNavigation-module-scss-module__twgJ1a__navButton",
  "navigation": "DesktopNavigation-module-scss-module__twgJ1a__navigation",
  "nestedItem": "DesktopNavigation-module-scss-module__twgJ1a__nestedItem",
  "primaryLabel": "DesktopNavigation-module-scss-module__twgJ1a__primaryLabel",
  "secondaryLabel": "DesktopNavigation-module-scss-module__twgJ1a__secondaryLabel",
});
